import { BrowserModule }                    from '@angular/platform-browser';
import { RouterModule }                     from '@angular/router';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule}                         from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http }                 from '@angular/http';
import { BrowserAnimationsModule }          from '@angular/platform-browser/animations';
import {MdButtonModule, MdMenuModule }       from '@angular/material';
import { MdExpansionModule}                 from '@angular/material';


import { MaterialModule }                   from '@angular/material';
import { ChartsModule }                     from 'ng2-charts';
import { CalendarModule }                   from 'angular-calendar';
import { NgxDatatableModule }               from '@swimlane/ngx-datatable';
import { AgmCoreModule }                    from '@agm/core';
import { SqueezeBoxModule }                 from 'squeezebox';

import { AppRoutingModule }                 from './app-routing.module';

import { AppComponent }                     from './app.component';

// A2 Components
import { NavbarComponent }                  from './Dashboard/menus/top-navbar/top-navbar.component';
import { SidebarComponent }                 from './a2-components/sidebar/sidebar.component';
import { LogoComponent }                    from './Dashboard/logo/logo.component';
import { MainMenuComponent }                from './Dashboard/menus/main-menu/main-menu.component';
import { A2CardComponent }                  from './a2-components/card/card.component';
import { AlertComponent }                   from './a2-components/alert/alert.component';
import { BadgeComponent }                   from './a2-components/badge/badge.component';
import { BreadcrumbComponent }              from './a2-components/breadcrumb/breadcrumb.component';
import { FileComponent }                    from './a2-components/file/file.component';
import { NIHTimelineComponent }             from './a2-components/ni-h-timeline/ni-h-timeline.component';
import { AngularFontAwesomeModule }         from 'angular-font-awesome';
import {NgxPaginationModule}                from 'ngx-pagination';

// Extra pages
import { FooterComponent }                  from './Dashboard/footer/footer.component';
import { AdditionNavbarComponent }          from './a2-components/addition-navbar/addition-navbar.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DashboardComponent } from './Dashboard/dashboard.component';
import { SharedService} from './services/shared-service/shared.service';
import { ReportOverviewComponent } from './Dashboard/DashboardPages/report-overview/report-overview.component';
import { MailSentComponent } from './mail-sent/mail-sent.component';
import { SideMenuComponent } from './Dashboard/menus/main-menu/sidebar/menu-item-list.component';
import { MenuItemsComponent } from './Dashboard/menus/main-menu/sidebar/menu-items/menu-items-setup.component';
import { ServiceManagementComponent } from './Dashboard/DashboardPages/service-management/service-management.component';
import { SystemActivityComponent } from './Dashboard/DashboardPages/system-activity/system-activity.component';
import { CreateUserComponent } from './Dashboard/DashboardPages/User management/create-user/create-user.component';
import {
  DialogResultComponent,
  FreezeAccountComponent,
  ManageUsersComponent, WalletTransferComponent
} from './Dashboard/DashboardPages/User management/manage-agents/manage-users.component';
import { ManageCustomersComponent } from './Dashboard/DashboardPages/User management/manage-customers/manage-customers.component';
import { CreateRoleComponent } from './Dashboard/DashboardPages/Role management/create-role/create-role.component';
import { ManageRoleComponent } from './Dashboard/DashboardPages/Role management/manage-role/manage-role.component';
import { GeneralSettingsComponent } from './Dashboard/DashboardPages/System settings/general-settings/general-settings.component';
import { EmailContactComponent } from './Dashboard/DashboardPages/System settings/email-contact/email-contact.component';
import { SmtpComponent } from './Dashboard/DashboardPages/System settings/smtp/smtp.component';
import { SocialMediaComponent } from './Dashboard/DashboardPages/System settings/social-media/social-media.component';
import { PaymentComponent } from './Dashboard/DashboardPages/System settings/payment/payment.component';
import {AuthService} from './services/auth-service/auth-service.service';
import { CreateAdminComponent } from './Dashboard/DashboardPages/User management/create-admin/create-admin.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import {AnonymousService} from './services/anonymous-service';
import { EditRoleComponent } from './Dashboard/DashboardPages/Role management/edit-role/edit-role.component';
import {UserService} from './services/users-service/user-service';
import { AdminProfileComponent } from './Dashboard/DashboardPages/User management/admin-profile/admin-profile.component';
import {AdminChangePasswordComponent} from './Dashboard/DashboardPages/User management/admin-change-password/admin-change-password.component';
import { UserProfileComponent } from './Dashboard/DashboardPages/User management/user-page/user-profile.component';

import { CustomAlertComponent } from './util/custom-alert/custom-alert.component';
import {ErrorService} from './util/error_service/error.service';
import {EmailValidator} from 'ng2-validation/dist/email';
import {SortingService} from './util/sort-service/sorting.service';
import {
  AgentDialogComponent,
  AgentProfileComponent
} from './Dashboard/DashboardPages/User management/user-page/agent-account/agent-account.component';
import { UserAgentsComponent } from './Dashboard/DashboardPages/User management/user-page/user-agents/user-agents.component';
import { MatchPasswordDirective } from './util/match-password-directive/match-password.directive';
import { ManageAdminComponent } from './Dashboard/DashboardPages/User management/manage-admin/manage-admin.component';
import { PermissionsComponent } from './Dashboard/DashboardPages/User management/user-page/permissions/permissions.component';
import { ToastService} from './util/toast-service/toast.service';
import { ToastrModule } from 'ngx-toastr';
import { QuickFundingComponent } from './Dashboard/DashboardPages/funding/quick-funding/quick-funding.component';
import {
  ApproveFunding, DeclineFunding,
  FundRequestsComponent, ViewProofOfPayment
} from './Dashboard/DashboardPages/funding/fund-requests/fund-requests.component';
import { FundHistoryComponent } from './Dashboard/DashboardPages/funding/fund-history/fund-history.component';
import {
  AirtimeComponent,
  ReportDialogComponent
} from './Dashboard/DashboardPages/Transactions/airtime/airtime.component';
import {
  WalletComponent ,
  WalletReportDialogComponent
} from './Dashboard/DashboardPages/transactions/wallet/wallet.component';

//pipes
import { FilterPipe } from './util/pipes/filter/filter.pipe';
import { MoneyFormatterPipe } from './util/pipes/money-formatter/money-formatter.pipe';
import { MainMenuService} from './Dashboard/menus/main-menu/main-menu.service';
import { MainMenu} from './Dashboard/menus/main-menu/mock-main-menu-items';
import { Page500Component } from './error-pages/page-500/page-500.component';
import { Page404Component } from './error-pages/page-404/page-404.component';
import { AuthGuard } from './services/Auth-guard/auth.guard';
import { TransactionsPipe } from './util/pipes/transactions-filter/airtime-transactions.pipe';
import { TransactionStatusFilterPipe } from './util/pipes/transactions-status-filter/transaction-status-filter.pipe';
import { FundRequestFilterPipe } from './util/pipes/fund-request-filter/fund-request-filter.pipe';
import { WalletTransactionsPipe } from './util/pipes/transactions-filter/wallet-transactions.pipe';
import {
  FundAgentsComponent,
  fundDialogComponent
} from './Dashboard/DashboardPages/funding/fund-agents/fund-agents.component';
import { UserStatusFilterPipe } from './util/pipes/user-status-filter/user-status-filter.pipe';
import {
  detailsDialogComponent,
  FrozenAccountsComponent
} from './Dashboard/DashboardPages/frozen-accounts/frozen-accounts.component';
import { CustomerProfileComponent } from './Dashboard/DashboardPages/User management/user-page/customer-account/customer-account.component';
import { AdminAccountComponent } from './Dashboard/DashboardPages/User management/user-page/admin-account/admin-account.component';
import {
  NetworkDialogComponent,
  NetworksConfigurationComponent
} from './Dashboard/DashboardPages/networks-configuration/networks-configuration.component';
import { FundRequestHistoryFilterPipe } from './util/pipes/fund-request-history/fund-request-history-filter.pipe';
import {DataComponent, DataDialogComponent} from './Dashboard/DashboardPages/Transactions/data/data.component';
import { CheckNullPipe } from './util/pipes/check-null.pipe';
import {TransactionsConfigurationComponent} from "./Dashboard/DashboardPages/transactions-configuration/transactions-configuration.component";


@NgModule({
  imports: [
    ToastrModule.forRoot(),
    BrowserModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    MaterialModule,
    MdButtonModule,
    MdMenuModule,
    MdExpansionModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpModule,
    ChartsModule,
    CalendarModule.forRoot(),
    NgxDatatableModule,
    AngularFontAwesomeModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAU9f7luK3J31nurL-Io3taRKF7w9BItQE'
    }),
    SqueezeBoxModule
  ],
  declarations : [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    AdminChangePasswordComponent,
    LogoComponent,
    MainMenuComponent,
    A2CardComponent,
    AlertComponent,
    BadgeComponent,
    BreadcrumbComponent,
    FileComponent,
    NIHTimelineComponent,

    FooterComponent,
    AdditionNavbarComponent,
    SignInComponent,
    ForgotPasswordComponent,
    DashboardComponent,
    ReportOverviewComponent,
    MailSentComponent,
    SideMenuComponent,
    MenuItemsComponent,
    ServiceManagementComponent,
    SystemActivityComponent,
    CreateUserComponent,
    ManageUsersComponent,
    ManageCustomersComponent,
    CreateRoleComponent,
    ManageRoleComponent,
    GeneralSettingsComponent,
    EmailContactComponent,
    EmailValidator,
    SmtpComponent,
    SocialMediaComponent,
    DialogResultComponent,
    WalletTransferComponent,
    FreezeAccountComponent,
    fundDialogComponent,
    PaymentComponent,
    CreateAdminComponent,
    NewPasswordComponent,
    EditRoleComponent,
    AdminProfileComponent,
    UserProfileComponent,
    CustomAlertComponent,
    AgentProfileComponent,
    UserAgentsComponent,
    MatchPasswordDirective,
    ManageAdminComponent,
    PermissionsComponent,
    QuickFundingComponent,
    FilterPipe,
    MoneyFormatterPipe,
    Page500Component,
    Page404Component,
    AirtimeComponent,
    FundRequestsComponent,
    TransactionsPipe,
    TransactionStatusFilterPipe,
    WalletComponent,
    ApproveFunding,
    DeclineFunding,
    ViewProofOfPayment,
    FundHistoryComponent,
    FundRequestFilterPipe,
    WalletTransactionsPipe,
    FundAgentsComponent,
    UserStatusFilterPipe,
    FrozenAccountsComponent,
    detailsDialogComponent,
    NetworkDialogComponent,
    ReportDialogComponent,
    WalletReportDialogComponent,
    CustomerProfileComponent,
    AdminAccountComponent,
    NetworksConfigurationComponent,
    TransactionsConfigurationComponent,
    FundRequestHistoryFilterPipe,
    AgentDialogComponent,
    DataComponent,
    DataDialogComponent,
    CheckNullPipe
  ],
  entryComponents: [ DialogResultComponent, WalletTransferComponent, AgentDialogComponent, WalletReportDialogComponent, DataDialogComponent, ReportDialogComponent, NetworkDialogComponent, FreezeAccountComponent, fundDialogComponent, ApproveFunding, DeclineFunding, ViewProofOfPayment, detailsDialogComponent],
  providers: [SharedService, ErrorService, AuthService, AnonymousService, UserService, SortingService, ToastService,  MainMenuService, MainMenu, AuthGuard],
  bootstrap: [ AppComponent ]

})

export class AppModule {

}




// WEBPACK FOOTER //
// ./src/app/app.module.ts